import * as Mod1 from "./discourse/adapters/user-note";
import * as Mod2 from "./discourse/components/modal/user-notes";
import * as Mod3 from "./discourse/components/post-metadata-user-notes";
import * as Mod4 from "./discourse/components/show-user-notes";
import * as Mod5 from "./discourse/components/user-note";
import * as Mod6 from "./discourse/connectors/after-reviewable-post-user/show-user-notes-on-flags.gjs";
import * as Mod7 from "./discourse/connectors/reviewable-note-form-after-note/copy-reviewable-note-to-user-option.gjs";
import * as Mod8 from "./discourse/connectors/user-card-post-names/show-user-notes-on-card.gjs";
import * as Mod9 from "./discourse/connectors/user-profile-controls/show-notes-on-profile.gjs";
import * as Mod10 from "./discourse/initializers/enable-user-notes";
import * as Mod11 from "./discourse/lib/user-notes";
import * as Mod12 from "./discourse/pre-initializers/user-notes-transformers";
const compatModules = {
  "discourse/adapters/user-note": Mod1,
  "discourse/components/modal/user-notes": Mod2,
  "discourse/components/post-metadata-user-notes": Mod3,
  "discourse/components/show-user-notes": Mod4,
  "discourse/components/user-note": Mod5,
  "discourse/connectors/after-reviewable-post-user/show-user-notes-on-flags": Mod6,
  "discourse/connectors/reviewable-note-form-after-note/copy-reviewable-note-to-user-option": Mod7,
  "discourse/connectors/user-card-post-names/show-user-notes-on-card": Mod8,
  "discourse/connectors/user-profile-controls/show-notes-on-profile": Mod9,
  "discourse/initializers/enable-user-notes": Mod10,
  "discourse/lib/user-notes": Mod11,
  "discourse/pre-initializers/user-notes-transformers": Mod12,
};
export default compatModules;
